<!--
 * @Autor: maopingping
 * @Date: 2022-03-24 14:37:00
 * @LastEditTime: 2022-12-19 15:22:04
 * @LastEditors: pingping.mao
 * @Description: 参数配置-列表
 * @FilePath: \common-web\src\views\standard\parameter-config\parameter-config-list.vue
-->
<template>
  <TreeListLayoutAdapter class="paramster-config-list">
    <!-- 左侧tree -->
    <template v-slot:tree>
      <el-tree
        ref="tree"
        class="self-tree"
        :props="defaultProps"
        :data="treeData"
        :node-key="'id'"
        :highlight-current="true"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
      >
        <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
          <span style="padding-right: 10px;">{{ node.label }}</span>
        </span>
      </el-tree>
    </template>
    <template v-slot:datatable>
      <template  v-for="item in treeData">
        <ParameterItem v-if="currentNode.id === item.id" :key="item.id" :templatedNode="currentNode" style="height: 100%" />
      </template>
      
    </template>
  </TreeListLayoutAdapter>
  
</template>

<script>
import parameterConfigApi from "@/api/parameter-config";
import ParameterItem from "./parameter-item.vue";
export default {
  name: "ParameterConfigList",
  components: {ParameterItem},
  data(){
    return {
      defaultProps: {
        label: "belongModuleName",
        children: "children",
      },
      treeData: [],
      currentNode: null
    };
  },
  created(){
    this.getParamsTemplate();
  },
  methods: {
    getParamsTemplate(){
      parameterConfigApi.getParamsTemplate().then(res => {
        if (res && res.data){          
          this.treeData = res.data || [];
          if (this.treeData.length === 0) return;
          this.currentNode = this.treeData[0];
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.currentNode.id);
          });
        }
      });
    },
    handleNodeClick(node){
      this.formData = {};
      this.currentNode = node;
    },
  }
};
</script>
<style lang="scss"></style>

